import React from "react"
import {useQuery} from "react-query"
import useAuth from "auth/useAuth"
import RescuesInfo from "./RescuesInfo"
import RescuesChart from "./RescuesChart"
import RescuersTable from "./RescuersTable"
import Spinner from "components/Spinner"
import Moment from "components/Moment"


export default function TotalTab() {

    const {auth, API} = useAuth()
    const {data, isLoading} = useQuery(
        ["total_rescues"],
        () => auth(API.analyticsTypeGet, {type: 'total_rescues', season: ''}).then(response => response.data)
    )
    
    return <>
        <h1>Ukupno</h1>

        <p>
            Podaci o povredama su dostupni od početka kalendarske 2005. godine.<br/>
            Izveštaj se osvežava svake ponoći.
            {data?.created_at && <><br/>Poslednje ažuriranje: <Moment date={data.created_at}/></>}
        </p>

        {isLoading ? <Spinner/> : <>
            <RescuesInfo data={data?.areas}/>
            <RescuesChart data={data?.seasons} subtitle="po sezonama i skijalištima"/>
            <RescuersTable data={data?.rescuers}/>
        </>}
    </>
}
